import { useTranslation } from "react-i18next";
import { UserWithAvatar } from "../../userWithAvatar/UserWithAvatar";
import { IPersonBadge } from "../../../../../../../common/types";

export const useDeactivateTable = (badgesToDeactivate: IPersonBadge[]) => {
  const { t } = useTranslation("common");

  const options = {
    download: false,
    search: false,
    sort: false,
    selectableRows: "none" as any,
    print: false,
    filter: false,
    viewColumns: false,
    rowsPerPageOptions: [],
    pagination: false
  };

  const columns = [
    {
      name: t("companyPage.table.name"),
      options: {
        customBodyRender: val => <UserWithAvatar name={val} />
      }
    }
  ];

  const getTableData = () => {
    return badgesToDeactivate.map(badge => ([`${badge.contact.firstName} ${badge.contact.lastName}`]));
  }

  return { options, columns, tableData: getTableData() };
};
